import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { HouseOccupantDataProvider } from "../../data-provider/house-occupant.dp";
import { Campaign } from "../../models/campaign.model";
import { Field } from "../../models/field.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";

let PeoplePaneComponent = {
    selector: "vcPeoplePane",
    templateUrl: "/angular/components/people/people-pane.component.html",
    bindings: {
        houseoccupant: "=?",
        size: "=",
        issuepage: "=?",
    },
    controller: class PeoplePaneController {
        // * bindings for typescript compiler *
        public houseoccupant?: any;
        public size: any;
        public issuepage?: any;
        // ************************************

        private isLeaderView: boolean;
        private activeCampaign: Campaign;
        private consentSettings: any = null;
        private consentedContactTypes: string = "";

        private $scope: any;
        private dialog: DialogUtils;
        private __env: any;
        private __app_type: string;

        private permissionCheck: PermissionCheck;
        private campaignDataProvider: CampaignDataProvider;
        private houseOccupantDataProvider: HouseOccupantDataProvider;
        private fieldDataProvider: FieldDataProvider;

        public contactFields: Field[];
        public generalFields: Field[];
        public otherFields: Field[];

        constructor(
            $scope: any,
            __env: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider,
            HouseOccupantDataProvider: HouseOccupantDataProvider,
            FieldDataProvider: FieldDataProvider
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.__env = __env;
            this.__app_type = __app_type;

            this.permissionCheck = PermissionCheck;
            this.campaignDataProvider = CampaignDataProvider;
            this.houseOccupantDataProvider = HouseOccupantDataProvider;
            this.fieldDataProvider = FieldDataProvider;

            this.isLeaderView = __app_type == "LEADER";
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();

            this.permissionCheck
                .getConsentSettings()
                .then((consentSettings) => {
                    this.consentSettings = consentSettings;
                });

            this.fieldDataProvider.getAllFields(true).then(() => {
                [this.contactFields, this.generalFields, this.otherFields] =
                    this.fieldDataProvider.combinedFields;
            });
        }

        $onInit() {
            this.houseoccupant.integrationLinks = null;

            if (this.houseoccupant.hoid) {
                this.houseOccupantDataProvider
                    .integrationLinks(this.houseoccupant)
                    .then((integrationLinks) => {
                        this.houseoccupant.integrationLinks = integrationLinks;
                    });
            }
        }

        houseOccupantValue(field: Field): any {
            switch (true) {
                case field.hokey === "email":
                    return this.houseoccupant.hoemail;
                case field.hokey === "mobilephone":
                    return this.houseoccupant.homobilephone;
                case field.hokey === "homephone":
                    return this.houseoccupant.hohomephone;
                case field.hokey === "gender":
                    return this.houseoccupant.hogender;
                case field.hokey === "employment":
                    return this.houseoccupant.esname;
                case field.hokey === "party":
                    return this.houseoccupant.hoparty;
                case field.hokey === "dob":
                    return this.houseoccupant.hodob;
                case field.hokey === "yob":
                    return this.houseoccupant.hoyob;
                case field.hokey === "volunteer":
                    return this.houseoccupant.hovolunteer;
                case field.hokey === "deceased":
                    return this.houseoccupant.hodeceased;
                case field.hokey === "donor":
                    return this.houseoccupant.hodonor;
                case field.hokey === "income":
                    return this.houseoccupant.income;
                case field.hokey === "credit_rating":
                    return this.houseoccupant.credit_rating;
                case field.hokey === "donor_environmental":
                    return this.houseoccupant.donor_environmental;
                default:
                    return;
            }
        }

        populatedFields(customfields: any): Array<any> {
            if (customfields) {
                return customfields.filter((customfield: any) => {
                    if (customfield.cfid) {
                        return customfield.value || customfield.hocfvalue;
                    }
                });
            } else {
                return [];
            }
        }

        populatedElections(elections: any): Array<any> {
            if (elections) {
                return elections.filter((election: any) => {
                    return election.hoevalue;
                });
            } else {
                return [];
            }
        }

        populatedContactMethods(contactMethods: any): Array<any> {
            if (contactMethods) {
                return contactMethods.filter((contactMethod: any) => {
                    return contactMethod.selected == 1;
                });
            } else {
                return [];
            }
        }

        openViewHouseDialog(hid: any, ev: any): void {
            this.dialog.show({
                component: "vc-view-house",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    selectedHid: hid,
                    selectedHouse: null,
                },
            });
        }

        selectedOptions(options: any): Array<any> {
            if (options) {
                return options.filter((option) => {
                    return option.selected == 1;
                });
            } else {
                return [];
            }
        }

        openViewIntegrationErrorDialog(
            integration_name: any,
            data: any,
            ev: any
        ): void {
            this.dialog
                .show({
                    component: "vc-general-info-code",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        bodyText:
                            "This contact could not be sent to " +
                            integration_name +
                            " due to the following error:",
                        title: `Sync Error`,
                        code: data.error,
                        buttonText: {
                            cancel: "",
                            confirm: "Dismiss",
                        },
                    },
                })
                .then((data) => {});
        }
    },
};

angular
    .module("people")
    .component(PeoplePaneComponent.selector, PeoplePaneComponent);
